import { environment } from "./util.environment.js";
import { makeEnvironmentRef } from "./util.make-environment-ref.js";
import { z } from "zod";
//#region src/env/parser.enum.ts
/**
* get a configuration that conforms to an enumeration of allowed values,
* falling back to the given default if an invalid input was provided.
*/
function asEnum(key, options) {
	const schema = options.defaultValue ? z.enum(options.values).catch(options.defaultValue).default(options.defaultValue) : z.enum(options.values);
	return makeEnvironmentRef(() => schema.parse(environment.read(key, { optional: !!options.defaultValue })));
}
//#endregion
export { asEnum };

//# sourceMappingURL=parser.enum.js.map